import styled from 'styled-components'
import {
  getTypographyIntent,
  typographyWeights,
} from '../Typography/Typography.styles'
import { spacing } from '../_styles/spacing'

export const optionMinHeight = 32
/** Large enough to fit one group and one item */
export const defaultMenuHeight = 64

export const StyledOptions = styled.div``

export const StyledItem = styled.div`
  ${getTypographyIntent('body')};

  padding: ${spacing.xs}px ${spacing.md}px;
  cursor: pointer;
  list-style-type: none;
`

export const StyledGroup = styled.div`
  ${getTypographyIntent('body')};

  padding: ${spacing.md}px ${spacing.md}px ${spacing.xs}px;
  font-weight: ${typographyWeights.semibold};
  background: white;
  list-style-type: none;
`
